import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { map } from "rxjs/operators";
import { apiConstants } from "../constant/apiConstant";

@Injectable()
export class NewLoginServices {
  private url = AppSettings.API_ENDPOINT_V3;
  private genericLoginWithOtp = apiConstants.genericLoginWithOtp;
  private genericLoginWithPassword = apiConstants.genericLoginWithPassword;
  private verifyOtpForGenericLogin = apiConstants.verifyOtpForGenericLogin;
  constructor(private http: HttpClient) {}
  headers: HttpHeaders;
  genericLoginWithOtpApi(body: any) {
    return this.http
      .post(`${this.url}${this.genericLoginWithOtp}`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }
  genericLoginWithPasswordApi(body) {
    return this.http
      .post(`${this.url}${this.genericLoginWithPassword}`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }
  verifyingOtpForGenericLoginApi(body: any) {
    return this.http
      .post(`${this.url}${this.verifyOtpForGenericLogin}`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }
}
